import { render, staticRenderFns } from "./signature.vue?vue&type=template&id=d8927c7e&scoped=true&"
import script from "./signature.vue?vue&type=script&lang=ts&"
export * from "./signature.vue?vue&type=script&lang=ts&"
import style0 from "./signature.vue?vue&type=style&index=0&id=d8927c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8927c7e",
  null
  
)

export default component.exports